import { render, staticRenderFns } from "./CoachDetailProfile.vue?vue&type=template&id=53023132&scoped=true&lang=pug"
import script from "./CoachDetailProfile.vue?vue&type=script&lang=js"
export * from "./CoachDetailProfile.vue?vue&type=script&lang=js"
import style0 from "./CoachDetailProfile.vue?vue&type=style&index=0&id=53023132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53023132",
  null
  
)

export default component.exports